import React, { useState } from 'react';
import ErrorMessages from '../components/ErrorMessages';
import { Input } from '../components/forms';
import { Button, ButtonFilled, ScrollView } from '../components/ui';
import logo from '../images/mark-blue.svg';
import { useMutation } from 'react-apollo-hooks';
import { LoginMutation, LoginMutationVariables } from '../queries/__generated__/LoginMutation';
import { loginMutation } from '../queries/user';
import { setAuthToken } from '../lib/auth';
import redirect from '../lib/redirect';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<{ message: string }[]>([]);
  const login = useMutation<LoginMutation, LoginMutationVariables>(loginMutation, {
    variables: { email, password }
  });

  function handleSubmit(e: React.SyntheticEvent) {
    e.preventDefault();
    login()
      .then(res => {
        const { token, errors } = res.data!.login;

        if (errors) {
          setErrors(errors);
        }

        if (token) {
          setAuthToken(token);
          redirect('/');
        }
      })
      .catch(err => console.error(err));
  }

  return (
    <ScrollView className="flex-auto flex flex-column items-center justify-between pa4 fixed absolute--fill">
      <img className="w2" src={logo} alt="Quala" />

      {/* Login Form */}
      <div>
        <h1 className="f3 f2-ns display tc">Log in</h1>

        {!!errors.length && (
          <div className="tc mv3">
            <ErrorMessages errors={errors} />
          </div>
        )}

        <form className="mw5 tc" onSubmit={e => handleSubmit(e)}>
          <Input
            wrapperClassName="mb3"
            className="tc"
            label="email"
            id="email"
            type="email"
            name="email"
            onChange={e => setEmail(e.currentTarget.value)}
            value={email}
          />

          <Input
            wrapperClassName="mb4"
            className="tc"
            label="Password"
            id="password"
            type="password"
            name="password"
            onChange={e => setPassword(e.currentTarget.value)}
            value={password}
          />

          <ButtonFilled className="dib" data-testid="login-button">
            Login
          </ButtonFilled>
        </form>
      </div>

      {/* Request Access */}
      <div className="tc mt4">
        <a href="mailto:support@quala.io?subject=Early Access">
          <Button>Request Early Access</Button>
        </a>
      </div>
    </ScrollView>
  );
};

export default Login;
